export default __webpack_public_path__ + "static/media/logo-automotor.875ae96f.webp";